export const MARKER_XHR = 'headless';
export const LayerContentHTML = () => {
    return null;
};
//# sourceMappingURL=LayerContentHTML.js.map